export enum PaintBrushMode {
    Modify,
    Replace
}
